<template>
  <div>
    <b-row>
      <b-col>
        <h5>{{ caption }}</h5>
      </b-col>
    </b-row>

    <br/>
    <br/>

    <b-row>
      <b-col>
        <b-form-group>
          <label class="mb-0">Tipos</label>
          <b-form-select v-model="type_filter" >
            <template slot="first">
              <option :value="null">-- Seleccione --</option>
            </template>
            <option v-for="item in lstType" :key="item.code" :value="item.code">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_created_at.startDate"
            :max="
              range_created_at.endDate == ''
                ? maxDate
                : range_created_at.endDate
            "
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_created_at.endDate"
            :min="range_created_at.startDate"
            :max="maxDate"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Cobrador</label>
          <b-form-select v-model="staff_id_filter" :disabled="role_id == 4">
            <template slot="first">
              <option :value="null">-- Responsable--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 8">
        <b-form-group>
          <label for="cmbStaff" class="mb-0">Comercial</label>
          <b-form-select
            v-model="customer_staff_id_filter"
            id="cmbStaff"
          >
            <template slot="first">
              <option :value="null">-- Comercial --</option>
            </template>
            <option
              v-for="item in lstComercialStaffs"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4"></b-col>
      <b-col sm="2">
        <button
            class="btn btn-primary col-sm-12"
            type="button"
            @click="getData()"
          >
            Buscar
          </button>
      </b-col>
      <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="items"
          worksheet="Analisis Cartera"
          :name="file_name"
          :fields="getJsonDowload()"
          :before-generate = "startDownload"
          :before-finish   = "finishDownload"
          >Exportar
        </downloadExcel>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
export default {
  name: "ExportPrejury",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "SISITEMA DE EXPORTACIÓN PREJURIDICA",
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created_at: {
        startDate: moment(String(new Date("2009", "12", "01"))).format("YYYY-MM-DD"),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },

      file_name: null,
      items: [],
      lstType: [
        { code: 'A', name: "Abonos" } ,
        { code: 'G', name: "Gestiones" } ,
        { code: 'C', name: "Condiciones Iniciales de Cartera" } ,
      ],
      type_filter: null,
      disabled_export: true,      
      staff_id_filter: null,
      customer_id_filter: null,
      customer_staff_id_filter: null,

      // LISTAS PARA LOS FILTROS
      lstStaffs: [],
      lstComercialStaffs: [],
      
      lstCustomers: [],

    };
  },
  mounted() {
    this.initParameters();
  },
  methods: {
    initParameters() {
      // LISTA DE CUENTAS
      var auth = localStorage.getItem("auth");
      let authAux = JSON.parse(auth);
      this.isCustomer = authAux[0].customer_id != null ? true : false;
      this.staff_id_filter = this.role_id == 1 || this.role_id == 8 ? null : authAux[0].staff_id;

      let url = `${this.$urlApi}customers/staff?token=${this.token}`;

      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          (response) => {
            console.log(response);
            this.lstCustomers = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );

      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    getData () {
      this.disabled_export = true;
      this.file_name = null;
      if (this.type_filter != null)
      {
        switch (this.type_filter) 
        {
          case "A": // ABONOS
            this.file_name = "Abonos.xls";
            this.getPaymenst();
            break;

          case "G": // GESTIONES
            this.file_name = "Gestiones.xls";
            this.getTaskmMnagements();
            break;

          case "C": // CONDICIONES INICIALES
            this.file_name = "CondicionesIniciales.xls";
            this.getInvoices();
            break;
        }
      }
      else
      {
        this.$swal({
          title: "Advertencia",
          text: "No ha seleccionado ningún tipo de exportación!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar"
        });
      }
      
    },
    getPaymenst () {
      showLoader();
      let authAux = JSON.parse(this.auth);
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].image = null;

      if (this.customer_id_filter) {
        authAux[0].customer_id = this.customer_id_filter;
      }

      authAux[0].start_date_created_at = moment(this.range_created_at.startDate).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(this.range_created_at.endDate).format("YYYY-MM-DD");

      let url = `${this.$urlApi}export/payments?token=${this.token}`;
      
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.items = response.data.data;
            hideLoader();
            this.disabled_export = true;
            this.$swal({
              title: "Buen trabajo",
              text: response.data.count + " Abonos encontrados!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getTaskmMnagements () {
      showLoader();
      let authAux = JSON.parse(this.auth);
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].image = null;

      if (this.customer_id_filter) {
        authAux[0].customer_id = this.customer_id_filter;
      }

      authAux[0].start_date_created_at = moment(this.range_created_at.startDate).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(this.range_created_at.endDate).format("YYYY-MM-DD");

      let url = `${this.$urlApi}export/taskmanagements?token=${this.token}`;
      
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log('Gestiones:::::::', response.data.data);
            this.items = response.data.data;
            hideLoader();
            this.disabled_export = true;
            this.$swal({
              title: "Buen trabajo",
              text: response.data.count + " Gestiones encontradas!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getInvoices () {
      showLoader();
      let authAux = JSON.parse(this.auth);
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].image = null;

      if (this.customer_id_filter) {
        authAux[0].customer_id = this.customer_id_filter;
      }

      authAux[0].start_date_created_at = moment(this.range_created_at.startDate).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(this.range_created_at.endDate).format("YYYY-MM-DD");

      let url = `${this.$urlApi}export/invoices?token=${this.token}`;
      
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log('Gestiones:::::::', response.data.data);
            this.items = response.data.data;
            hideLoader();
            this.disabled_export = true;
            this.$swal({
              title: "Buen trabajo",
              text: response.data.count + " Registros encontradas!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    getJsonDowload () {
      let json_fields = {};
      switch (this.type_filter) 
      {
        case "A": // ABONOS
          
          json_fields = {
            "NOMBRE DEL CLIENTE": "customer_business_name",
            "NIT DEL CLIENTE": "customer_identification",
            "NOMBRE DEL DEUDOR": "debtor_business_name",
            "NIT DEL DEUDOR": "debtor_identification",
            "ESTADO DEL DEUDOR": "status_name",
            "TIIPIFICACION": "type_name",
            "VALOR DEL ABONO": {
            field: "value",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "DESTINO": "paid_to_name",
            "FECHA CREACIÓN DEL ABONO": "_created_at",
            "FECHA DEL ABONO": "_date",
            "STAFF QUE LO CREO": "staff_name",
            "COBRADOR": "collector_staff_name",
            "COMERCIAL QUE TIENE ACTUALMENTE EL CLIENTE": "commercial_staff_name",
            "CREO EL DEUDOR": "created_staff_name"
          };
          break;

        case "G": // GESTIONES
          json_fields = {
            "NOMBRE DEL CLIENTE": "customer_business_name",
            "NIT DEL CLIENTE": "customer_identification",
            "NOMBRE DEL DEUDOR": "debtor_business_name",
            "NIT DEL DEUDOR": "debtor_identification",
            "ESTADO DEL DEUDOR": "status_name",
            "TIIPIFICACION": "type_name",
            "STAFF QUE LO CREO": "staff_name",
            "COBRADOR": "collector_staff_name",
            "COMERCIAL QUE TIENE ACTUALMENTE EL CLIENTE": "commercial_staff_name",
            "CREO EL DEUDOR": "created_staff_name",
            "TIPO DE GESTIÓN": "task_type_name",
            "FECHA DE GESTIÓN": "_date",
            "DESCRIPCIÓN": "management",
            "TIPO / PUBLICO O PRIVADA": "privacy_name",
            "DURACIÓN": "minutes"            
          };
          break;

        case "C": // CONDICIONES INICIALES
          json_fields = {
            "NOMBRE DEL CLIENTE": "customer_business_name",
            "NIT DEL CLIENTE": "customer_identification",
            "NOMBRE DEL DEUDOR": "debtor_business_name",
            // "ID DEUDOR": "id",
            "NIT DEL DEUDOR": "debtor_identification",
            "ESTADO DEL DEUDOR": "status_name",
            "TIIPIFICACION": "type_name",
            "STAFF QUE LO CREO": "staff_name",
            "COBRADOR": "collector_staff_name",
            "COMERCIAL QUE TIENE ACTUALMENTE EL CLIENTE": "commercial_staff_name",  
            "NÚMERO DE FACTURAS": {
            field: "settlement.invoice_count",
              callback: (value) => {
                return value;
              },
            },  
            "CAPITAL INICIAL": {
            field: "settlement.capital",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "ABONOS PREVIOS": {
            field: "settlement.initial_payments",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            }, 
            "CAPITAL RECIBIDO POR TRÉBOL": {
            field: "settlement.capital_received_by_trebol",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "CAPITAL COBRADO": {
            field: "settlement.capital_recovered",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "CAPITAL POR COBRAR": {
            field: "settlement.capital_receivable",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "INTERESES": {
            field: "settlement.interest",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "ABONOS INTERESES": {
            field: "settlement.interests_recovered",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "INTERESES POR COBRAR": {
            field: "settlement.interests_receivable",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "TOTAL HONORARIOS": {
            field: "settlement.fee",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "ABONOS A HONORARIOS": {
            field: "settlement.fees_recovered",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "HONORARIOS POR COBRAR": {
            field: "settlement.fees_receivable",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
            "TOTAL POR COBRAR": {
            field: "settlement.total_receivable",
              callback: (value) => {
                return `${GformatPrice(value)}`;
              },
            },
          };
          
          break;
      }

      return json_fields;

    },

    startDownload() {
      console.log('startDownload::::::::::::');
      showLoader();
    },
    finishDownload() {
      console.log('finishDownload::::::::::::');
      hideLoader();
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    formatDateDescriotion(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },

  },
};
</script>
